import { useEffect, useState } from "react";

import useWarehouseLocations from "../../data/useWarehouseLocations";
import useWilmaUsers from "../../data/useWilmaUsers";
import { IWarehouseLocation } from "../../models/Location";
import formatDateTime from "../../utils/formatDateTime";

export default function WarehouseLocationFromId({ id, lastStockChecked, locatedById }: { id: string | null, lastStockChecked?: string | null, locatedById?: string | null }) {
  const { warehouseLocations } = useWarehouseLocations();
  const { wilmaUsers } = useWilmaUsers();
  const [location, setLocation] = useState<IWarehouseLocation | undefined>(undefined);
  const [loading, setLoading] = useState(true);
  const [locatedBy, setLocatedBy] = useState<string | null>(null);

  useEffect(() => {
    if (!warehouseLocations.isLoading && warehouseLocations.data) {
      const location = warehouseLocations.data.data.find((location) => location.id === id);
      setLocation(location);
      setLoading(false);
    }
  }, [warehouseLocations.data, warehouseLocations.isLoading, id]);

  useEffect(() => {
    if (locatedById && !wilmaUsers.isLoading && wilmaUsers.data) {
      const user = wilmaUsers.data.data.find((user) => user.id === locatedById);
      setLocatedBy(user ? user.fullname : "Unknown User");
    }
  }, [locatedById, wilmaUsers.data, wilmaUsers.isLoading]);

  if (loading) {
    return <span>Loading...</span>;
  }

  return (
    <div>
      {!location ? <span>Not Found</span> : <span>{location.displayName}</span>}
      {lastStockChecked && <p className="text-xs text-gray-700">Last Stock Checked: {formatDateTime(lastStockChecked)}</p>}
      {locatedBy && <p className="text-xs text-gray-700">Located By: {locatedBy}</p>}
    </div>
    );
}